import { createSlice } from '@reduxjs/toolkit';
import { MenuOptionState } from './types';
import {
  addMenuOption,
  fetchMenuOptions,
  fetchMenuOptionGroups,
  addMenuOptionToGroupApi,
  removeMenuOptionFromGroupApi,
  addMenuOptionGroupApi,
  updateMenuOptionGroupApi,
  deleteMenuOptionGroupApi,
  deleteMenuOptionApi,
  fetchMenuOptionMenuOptionGroup,
} from './menuOptionApi';

const initialState: MenuOptionState = {
  menuOptions: [],
  menuOptionGroups: [],
  menuOptionMenuOptionGroup: [],
  loading: false,
  error: null,
};

const menuOptionSlice = createSlice({
  name: 'menuOption',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Add Menu Option
    builder
      .addCase(addMenuOption.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMenuOption.fulfilled, (state, action) => {
        state.loading = false;
        state.menuOptions.push(action.payload);
      })
      .addCase(addMenuOption.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Fetch Menu Options
    builder
      .addCase(fetchMenuOptions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuOptions.fulfilled, (state, action) => {
        state.loading = false;
        state.menuOptions = action.payload;
      })
      .addCase(fetchMenuOptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Fetch Menu Option Groups
    builder
      .addCase(fetchMenuOptionGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuOptionGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.menuOptionGroups = action.payload;
      })
      .addCase(fetchMenuOptionGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Fetch Menu Option Menu Option Group
    builder
      .addCase(fetchMenuOptionMenuOptionGroup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMenuOptionMenuOptionGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.menuOptionMenuOptionGroup = action.payload;
      })
      .addCase(fetchMenuOptionMenuOptionGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Add Menu Option To Group
    builder
      .addCase(addMenuOptionToGroupApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMenuOptionToGroupApi.fulfilled, (state, action) => {
        state.loading = false;
        state.menuOptionMenuOptionGroup = action.payload;
      })
      .addCase(addMenuOptionToGroupApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Remove Menu Option From Group
    builder
      .addCase(removeMenuOptionFromGroupApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeMenuOptionFromGroupApi.fulfilled, (state, action) => {
        state.loading = false;
        state.menuOptionMenuOptionGroup = action.payload;
      })
      .addCase(removeMenuOptionFromGroupApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Add Menu Option Group
    builder
      .addCase(addMenuOptionGroupApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addMenuOptionGroupApi.fulfilled, (state, action) => {
        state.loading = false;
        state.menuOptionGroups.push(action.payload);
      })
      .addCase(addMenuOptionGroupApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Update Menu Option Group
    builder
      .addCase(updateMenuOptionGroupApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMenuOptionGroupApi.fulfilled, (state, action) => {
        state.loading = false;
        // 更新されたグループで一覧内の該当グループを差し替える
        const index = state.menuOptionGroups.findIndex((group) => group.id === action.payload.id);
        if (index !== -1) {
          state.menuOptionGroups[index] = action.payload;
        }
      })
      .addCase(updateMenuOptionGroupApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Delete Menu Option Group
    builder
      .addCase(deleteMenuOptionGroupApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMenuOptionGroupApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteMenuOptionGroupApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Delete Menu Option
    builder
      .addCase(deleteMenuOptionApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMenuOptionApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteMenuOptionApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export {
  addMenuOption,
  fetchMenuOptions,
  fetchMenuOptionGroups,
  addMenuOptionToGroupApi as addMenuOptionToGroup,
  removeMenuOptionFromGroupApi as removeMenuOptionFromGroup,
  addMenuOptionGroupApi as addMenuOptionGroup,
  updateMenuOptionGroupApi as updateMenuOptionGroup,
  deleteMenuOptionGroupApi as deleteMenuOptionGroup,
  deleteMenuOptionApi as deleteMenuOption,
  fetchMenuOptionMenuOptionGroup,
};

export default menuOptionSlice.reducer;
